import React from 'react';

const ProjectDescription = function(props) {
  return (
    <div>
      <p>
        The internal spaces of this previously gloomy late-Victorian property,
        are now flooded with natural light, drawn into the space by creating
        long views through the property from the street to the garden, and with
        a faceted light shaft over the open-plan staircase.
      </p>
      <p>
        The centralised wall has been removed between the Living and Dining
        areas, creating a grandeur to the entire ground floor area. Other ground
        floor walls are carefully positioned to comfortably connect different
        spaces with connecting views and expansive natural light. A light-shaft
        above the staircase with glass balustrades brings natural light from
        above into the dining area in the heart of the home.
      </p>
      <p>
        The interior design approach has created a quiet, gallery-like series
        of spaces, allowing the clients possessions and paintings to be
        displayed with quiet support from the white-washed architecture.
      </p>
      <p>
        <blockquote>
        “Matt was our guiding figure for the complete refurbishment. He took
        time and was patient and dedicated and kept us informed, listened to our
        opinions, and gave a complete and personal service.<br /><br />
        He was imaginative in his design, he monitored the complete progress of
        the works and tailored any changes to our preferences.<br /><br />
        We have no hesitation in recommending him. All our family and friends
        who have visited are awestruck at the changes that have taken place to
        make our home special and this is due to the efforts of Matt.”<br /><br />
        </blockquote>
        <cite>Jan and Paul</cite>
      </p>
    </div>
  );
}

export default ProjectDescription;



// WEBPACK FOOTER //
// ./src/components/projects/willow-walk-remodelling.jsx